import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Card,
  Layout,
  Skeleton,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  getDocumenti,
  postDownloadDocumenti,
  setConfermaFirma,
  setStartFirma,
} from "../services/api";
import {
  CheckCircleOutlined,
  DownloadOutlined,
  FormOutlined,
  LoadingOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";
import { pdfjs, Document, Page } from "react-pdf";
import logo from "./../assets/img/BAIndipendenti.png";
const { Content, Sider, Header } = Layout;
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const { innerWidth, innerHeight } = window;

const DocScreen = () => {
  const navigate = useNavigate();
  const [documenti, setDocumenti] = useState();
  const [otpFirma, setOtpFirma] = useState();
  const [idDoc, setIdDoc] = useState();
  const [loadingDoc, setLoadingDoc] = useState();
  const [loadingOtp, setLoadingOtp] = useState();
  const [loadingOpenDoc, setLoadingOpenDoc] = useState();
  const [loadingDownloadDoc, setLoadingDownloadDoc] = useState();
  const [loadingSignDoc, setLoadingSignDoc] = useState();
  const [loadingSignDocCarta, setLoadingSignDocCarta] = useState();
  const [filePdf, setFilePdf] = useState();
  const [numPages, setNumPages] = useState(null);
  const [doc, setDoc] = useState();
  const [carta, setCarta] = useState();
  const [isMobile, setIsMobile] = useState(false);
  const [docOpen, setDocOpen] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    if (/Android|iPhone/i.test(window.navigator.userAgent)) {
      setIsMobile(true);
    }
    fetchDoc();
  }, []);

  const fetchDoc = async () => {
    setLoadingDoc(true);
    const idPratica = localStorage.getItem("id_pratica");
    const token = localStorage.getItem("token");
    const data = {
      id_pratica: idPratica,
    };
    getDocumenti(data, token)
      .then((res) => {
        setDocumenti(res);
      })
      .catch((error) => {
        if (error == "Non Autorizzato") {
          if (localStorage.getItem('tokenOperatore')) {
            navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
          }
          else {
            if (localStorage.getItem("praticaTotem")) {
              localStorage.removeItem('praticaTotem');
              navigate('/homepage', { state: { isTotem: true } })
            }
            else {
              navigate('/homepage');
            }
          }
        } else {
          message.error(error);
        }
      })
      .finally(() => {
        setLoadingDoc();
      });
  };

  const downloadHandler = () => {
    // setLoadingDownloadDoc(id);
    const token = localStorage.getItem("token");
    const data = {
      id_documento: doc.id,
    };
    postDownloadDocumenti(data, token)
      .then((res) => {
        const blob = new Blob([res], {
          type: "application/pdf",
        });
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = `${doc.descrizione}.pdf`;
        alink.click();
        setLoadingDownloadDoc();
      })
      .catch((error) => {
        if (error == "Non Autorizzato") {
          navigate("/HomeScreen");
        } else {
          message.error(error);
        }
      })
      .finally(() => { });
  };

  const showHandler = (item) => {
    setLoadingOpenDoc(item.id);
    setDoc(item);
    setDocOpen(true);
    const idDocumento = item.id;
    const token = localStorage.getItem("token");
    const data = {
      id_documento: idDocumento,
    };
    postDownloadDocumenti(data, token)
      .then((res) => {
        const blob = new Blob([res], {
          type: "application/pdf",
        });
        const fileURL = window.URL.createObjectURL(blob);
        // setFilePdf(fileURL);
        setLoadingOpenDoc(false);
        // window.open(fileURL);
        var reader = new FileReader();
        reader.readAsDataURL(res);
        reader.onloadend = function () {
          var base64data = reader.result;
          setFilePdf(base64data);
        };
      })
      .catch((error) => {
        if (error == "Non Autorizzato") {
          navigate("/HomeScreen");
        } else {
          message.error(error);
        }
      })
      .finally(() => { });
  };

  const signatureHandler = (flg_carta) => {
    if (flg_carta) {
      setLoadingSignDocCarta(true);
    } else {
      setLoadingSignDoc(true);
    }
    // const idDocumento = id;
    // setIdDoc(idDocumento);
    const idPratica = localStorage.getItem("id_pratica");
    const token = localStorage.getItem("token");
    const data = {
      id_pratica: idPratica,
      flg_carta: flg_carta ? 1 : 0
    };
    setStartFirma(data, token)
      .then((res) => {
        const idTrack = res.id_track;
        setOtpFirma(idTrack);
      })
      .catch((error) => {
        if (flg_carta) {
          setCarta(false);
        }
        if (error == "Non Autorizzato") {
          navigate("/HomeScreen");
        } else {
          message.error(error);
        }
      })
      .finally(() => {
        if (flg_carta) {
          setLoadingSignDocCarta();
        } else {
          setLoadingSignDoc();
        }
      });
  };

  const handleOkOtp = () => {
    // setLoadingOtp(true);
    document.getElementById("otp_firma").click();
  };

  const handleCancelOtp = () => {
    setOtpFirma();
    setIdDoc();
    fetchDoc();
    setCarta(false);
  };

  const onFinishOtp = (value) => {
    if (value.otp) {
      setLoadingOtp(true);
      const token = localStorage.getItem("token");
      const idPratica = localStorage.getItem("id_pratica");
      const data = {
        id_pratica: idPratica,
        id_track: otpFirma,
        otp: value.otp,
        flg_carta: carta ? 1 : 0
      };
      setConfermaFirma(data, token)
        .then((res) => {
          setOtpFirma();
          setIdDoc();
          fetchDoc();
          setDoc();
          setLoadingOtp();
          form.setFieldsValue({
            otp: "",
          });
        })
        .catch((error) => {
          if (error == "Non Autorizzato") {
            navigate("/HomeScreen");
          } else {
            message.error(error);
          }
        })
        .finally(() => {
          setLoadingOtp();
          if (carta) {
            setCarta(false);
          }
        });
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <>
      <Layout hasSider>

        {!(isMobile && docOpen) &&
          <Sider
            width={isMobile ? "100%" : "27%"}
            style={{
              overflow: "auto",
              height: "100vh",
              position: "fixed",
              left: 0,
              top: 0,
              bottom: 0,
              backgroundColor: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "9%",
              }}
            >
              <div style={{ paddingTop: "7%" }}>
                <img
                  src={logo}
                  alt="Banco Azzoaglio"
                  width={"100%"}
                  style={{ paddingRight: 15, paddingLeft: 15, maxWidth: 220 }}
                />
              </div>
              <div style={{ marginTop: "15%" }}>
                {
                  isMobile &&
                  <div
                    style={{
                      marginTop: "-20px",
                      marginBottom: 30,
                      fontFamily: 'Poppins-Medium',
                      fontSize: 17,
                      color: "#0049EA"
                    }}>
                    Visualizza e firma i tuoi documenti
                  </div>
                }
                <div>
                  {documenti && documenti.no_docs && (
                    <>
                      <div
                        style={{
                          fontFamily: "Poppins-Medium",
                          fontSize: 22,
                          color: "#0049EA",
                          marginLeft: 15,
                          marginRight: 15,
                        }}
                      >
                        La lista dei tuoi documenti verrà mostrata qui quando sarà
                        disponibile
                      </div>
                      <Skeleton
                        active
                        style={{
                          width: "70%",
                          paddingTop: "15%",
                          marginLeft: 15,
                        }}
                      />
                      <Skeleton active style={{ width: "70%", marginLeft: 15 }} />
                    </>
                  )}
                  {documenti && !documenti.no_docs && documenti.firmati && (
                    <div
                      style={{
                        fontFamily: "Poppins-Medium",
                        fontSize: 22,
                        color: "#0049EA",
                        marginLeft: 15,
                        marginRight: 15,
                      }}
                    >
                      Hai firmato tutti i documenti, attendi la verifica.
                    </div>
                  )}
                  <div style={{
                    marginTop: 30,
                    marginLeft: 15,
                    marginRight: 15,
                    marginBottom: 50,
                  }}>
                    <div>
                      <span style={{ fontFamily: 'Poppins-Regular', color: 'rgb(0, 56, 151)', fontSize: 16 }}>Documenti:</span>
                    </div>
                    <div
                      style={{
                        marginTop: 30,
                        marginLeft: 15,
                        marginRight: 15,
                        marginBottom: 50,
                      }}
                    >
                      {documenti &&
                        documenti.documenti &&
                        documenti.documenti.map((item) => (
                          <div
                            key={item.id}
                            style={{ paddingTop: 5, marginTop: 10 }}
                          >
                            <div
                              onClick={() => showHandler(item)}
                              style={{
                                fontFamily:
                                  item.flg_firmato == 1
                                    ? "Poppins-SemiBold"
                                    : "Poppins-Regular",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginRight: 30,
                              }}
                            >
                              {item.descrizione}
                              {item.flg_firmato == 1 && (
                                <CheckCircleOutlined
                                  style={{
                                    color: "green",
                                    position: "absolute",
                                    right: 20,
                                  }}
                                />
                              )}
                              {item.flg_firmato != 1 && (
                                <FormOutlined
                                  style={{
                                    color: "#0049EA",
                                    position: "absolute",
                                    right: 20,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      {documenti && documenti.documenti && (
                        <>
                          {documenti && !documenti.firmati &&
                            <Button
                              type="primary"
                              onClick={() => signatureHandler(false)}
                              style={{
                                margin: 8,
                                backgroundColor: "#2574F2",
                                height: 33,
                                width: 100,
                                borderRadius: 6,
                                marginTop: 30,
                                marginLeft: -15
                              }}
                            >
                              {loadingSignDoc && (
                                <div>
                                  <LoadingOutlined
                                    style={{ fontSize: "19px", color: "white" }}
                                  />
                                </div>
                              )}
                              {!loadingSignDoc && (
                                <div
                                  style={{
                                    fontFamily: "Poppins-SemiBold",
                                    fontSize: 15,
                                  }}
                                >
                                  FIRMA
                                </div>
                              )}
                            </Button>
                          }
                        </>
                      )}
                    </div>
                    {
                      documenti &&
                      documenti.documenti_carta.length > 0 &&
                      <div>
                        <span style={{ fontFamily: 'Poppins-Regular', color: 'rgb(0, 56, 151)', fontSize: 16 }}>Documenti carta:</span>
                      </div>
                    }

                    <div
                      style={{
                        marginTop: 30,
                        marginLeft: 15,
                        marginRight: 15,
                        marginBottom: 50,
                      }}>
                      {documenti &&
                        documenti.documenti_carta &&
                        documenti.documenti_carta.map((item) => (
                          <div
                            key={item.id}
                            style={{ paddingTop: 5, marginTop: 10 }}
                          >
                            <div
                              onClick={() => showHandler(item)}
                              style={{
                                fontFamily:
                                  item.flg_firmato == 1
                                    ? "Poppins-SemiBold"
                                    : "Poppins-Regular",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginRight: 30,
                              }}
                            >
                              {item.descrizione}
                              {item.flg_firmato == 1 && (
                                <CheckCircleOutlined
                                  style={{
                                    color: "green",
                                    position: "absolute",
                                    right: 20,
                                  }}
                                />
                              )}
                              {item.flg_firmato != 1 && (
                                <FormOutlined
                                  style={{
                                    color: "#0049EA",
                                    position: "absolute",
                                    right: 20,
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      {documenti && documenti.documenti_carta && documenti.documenti_carta.length > 0 && (
                        <>
                          {documenti && !documenti.firmati &&
                            <Button
                              type="primary"
                              onClick={() => { signatureHandler(true); setCarta(true); }}
                              style={{
                                margin: 8,
                                backgroundColor: "#2574F2",
                                height: 33,
                                width: 100,
                                borderRadius: 6,
                                marginTop: 30,
                                marginLeft: -15
                              }}
                            >
                              {loadingSignDocCarta && (
                                <div>
                                  <LoadingOutlined
                                    style={{ fontSize: "19px", color: "white" }}
                                  />
                                </div>
                              )}
                              {!loadingSignDocCarta && (
                                <div
                                  style={{
                                    fontFamily: "Poppins-SemiBold",
                                    fontSize: 15,
                                  }}
                                >
                                  FIRMA
                                </div>
                              )}
                            </Button>
                          }
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{ paddingBottom: 20, cursor: "pointer", marginTop: '60px' }}
                onClick={() => {
                  navigate("/overview");
                }}
              >
                <div
                  style={{
                    fontFamily: "Poppins-Regular",
                    fontSize: 13,
                    color: "#0049EA",
                    marginLeft: 10,
                    textDecoration: "underline",
                  }}
                >
                  Torna indietro
                </div>
              </div>
            </div>
          </Sider>}

        {!isMobile &&
          <Layout
            className="site-layout"
            style={{ marginLeft: "27%", overflowY: "hidden" }}
          >
            <Content style={{ overflow: "initial", backgroundColor: "#eff4fd" }}>
              <div
                className="pol-content"
                style={{
                  height: "100vh",
                  display: "flex",
                  // alignItems: "center",
                  flexDirection: "column",
                  justifyContent: (!doc && (!documenti || (documenti && !documenti.no_docs))) ? 'center' : ''
                }}
              >
                {doc && (
                  <>
                    <div
                      style={{
                        color: "#003897",
                        fontFamily: "Poppins-SemiBold",
                        fontSize: 36,
                        paddingTop: 10,
                        paddingBottom: 20,
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      {doc.descrizione}
                    </div>
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: 'center'
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={downloadHandler}
                        style={{
                          margin: 10,
                          backgroundColor: "#2574F2",
                          height: 40,
                          width: 150,
                          borderRadius: 6,
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins-SemiBold",
                            fontSize: 18,
                          }}
                        >
                          SCARICA
                        </div>
                      </Button>
                    </div>
                  </>

                )}
                {!doc && (!documenti || (documenti && !documenti.no_docs)) && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "60%",
                      marginLeft: "20%"
                    }}
                  >
                    <div
                      style={{
                        color: "#003897",
                        fontFamily: "Poppins-SemiBold",
                        fontSize: 36,
                        paddingTop: 10,
                        paddingBottom: 20,
                      }}
                    >
                      I tuoi documenti
                    </div>
                    <div
                      style={{
                        color: "#003897",
                        fontFamily: "Poppins-Regular",
                        fontSize: 24,
                        textAlign: "center",
                      }}
                    >
                      Qui puoi vedere e firmare i tuoi documenti, seleziona dalla
                      lista il documento che vuoi visualizzare e scorri in basso
                      per firmarlo o scaricarlo
                    </div>
                  </div>
                )}
                {!doc && documenti && documenti.no_docs && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      width: "60%",
                      marginLeft: "20%"
                    }}
                  >
                    <div
                      style={{
                        color: "#003897",
                        fontFamily: "Poppins-Regular",
                        fontSize: 24,
                        textAlign: "center",
                      }}
                    >
                      Gentile cliente, i tuoi documenti sono in preparazione.
                      Riceverai un'email quando saranno disponibili
                    </div>
                  </div>
                )}
                {doc && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 20,
                      flexDirection: "column",
                    }}
                  >
                    {loadingOpenDoc && (
                      <div
                        style={{
                          padding: 20,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <LoadingOutlined
                          style={{ fontSize: "85px", color: "#023AAE" }}
                        />
                      </div>
                    )}
                    {!loadingOpenDoc && filePdf && (
                      <>

                        <div style={{ height: "80vh", overflowY: "scroll" }}>
                          <Document
                            file={filePdf}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={
                              <div
                                style={{
                                  padding: 20,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <LoadingOutlined
                                  style={{ fontSize: "85px", color: "#023AAE" }}
                                />
                              </div>
                            }
                          >
                            {Array.from({ length: numPages }, (_, index) => (
                              <Page
                                wrap={false}
                                width={800}
                                key={`page_${index + 1}`}
                                pageIndex={index}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                              >
                                <br />
                              </Page>
                            ))}
                          </Document>
                        </div>
                      </>

                    )}
                  </div>
                )}
              </div>
            </Content>
          </Layout>}
        {isMobile && docOpen &&
          <Layout>
            <Content
              style={{ backgroundColor: "white" }}>
              <div
                style={{
                  height: "100vh",
                  display: "flex",
                  // alignItems: "center",
                  flexDirection: "column",
                  justifyContent: (!doc && (!documenti || (documenti && !documenti.no_docs))) ? 'center' : ''
                }}>
                {doc && (
                  <>
                    <div
                      style={{
                        color: "#003897",
                        fontFamily: "Poppins-SemiBold",
                        fontSize: 20,
                        paddingTop: 10,
                        paddingBottom: 10,
                        marginTop: 20,
                        display: 'flex',
                        justifyContent: 'center'
                      }}
                    >
                      {doc.descrizione}
                    </div>
                    <div
                      style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: 'center'
                      }}
                    >
                      <Button
                        type="primary"
                        onClick={() => {
                          setDocOpen(false);
                        }}
                        style={{
                          margin: 10,
                          backgroundColor: "#2574F2",
                          height: 33,
                          width: 90,
                          borderRadius: 6,
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins-SemiBold",
                            fontSize: 12,
                          }}
                        >
                          INDIETRO
                        </div>
                      </Button>
                      <Button
                        type="primary"
                        onClick={downloadHandler}
                        style={{
                          margin: 10,
                          backgroundColor: "#2574F2",
                          height: 33,
                          width: 90,
                          borderRadius: 6,
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins-SemiBold",
                            fontSize: 12,
                          }}
                        >
                          SCARICA
                        </div>
                      </Button>
                    </div>
                  </>

                )}
                {!loadingOpenDoc && filePdf && (
                  <>

                    <div style={{ height: "75vh", overflowY: "scroll" }}>
                      <Document
                        file={filePdf}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading={
                          <div
                            style={{
                              padding: 20,
                              display: "flex",
                            }}
                          >
                            <LoadingOutlined
                              style={{ fontSize: "35px", color: "#023AAE" }}
                            />
                          </div>
                        }
                      >
                        {Array.from({ length: numPages }, (_, index) => (
                          <Page
                            wrap={false}
                            width={innerWidth}
                            key={`page_${index + 1}`}
                            pageIndex={index}
                            renderAnnotationLayer={false}
                            renderTextLayer={false}
                          >
                            <br />
                          </Page>
                        ))}
                      </Document>
                    </div>
                  </>

                )}
              </div>
            </Content>
          </Layout>
        }
      </Layout>

      <Modal open={otpFirma} closable={false} footer={null}>
        <div style={{ marginBottom: 80 }}>
          <div style={{ fontSize: 20, fontFamily: "Poppins-SemiBold" }}>
            Firma documento
          </div>
          <div>
            <div
              style={{
                marginBottom: 30,
                fontSize: 16,
                fontFamily: "Poppins-Regular",
                marginTop: 10,
              }}
            >
              Inserisci il codice che hai ricevuto per messaggio
            </div>
            <Form form={form} name="otpForm" onFinish={onFinishOtp}>
              <Form.Item
                name="otp"
                label={
                  <div
                    style={{
                      color: "#0A69E8",
                      fontSize: 20,
                      fontFamily: "Poppins-Medium",
                    }}
                  >
                    OTP
                  </div>
                }
                style={{ width: "80%" }}
                rules={[
                  {
                    required: true,
                    message: "Inserisci l'otp che hai ricevuto",
                  },
                ]}
              >
                <Input
                  style={{
                    borderWidth: 0,
                    borderBottomWidth: 1,
                    borderColor: "#0061DF",
                    fontSize: 20,
                    fontFamily: "Poppins-Regular",
                    marginLeft: 20,
                  }}
                />
              </Form.Item>
              <div hidden>
                <Form.Item label="OTP" name="otp">
                  <Button htmlType="submit" id="otp_firma" />
                </Form.Item>
              </div>
              <Button
                type="primary"
                onClick={handleOkOtp}
                style={{
                  backgroundColor: "#2574F2",
                  height: 40,
                  width: 100,
                  borderRadius: 6,
                  position: "absolute",
                  right: 20,
                  bottom: 20,
                }}
              >
                {loadingOtp && (
                  <div>
                    <LoadingOutlined
                      style={{ fontSize: "24px", color: "white" }}
                    />
                  </div>
                )}
                {!loadingOtp && (
                  <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>
                    AVANTI
                  </div>
                )}
              </Button>
            </Form>
          </div>
          <Button
            onClick={handleCancelOtp}
            style={{
              height: 40,
              width: 100,
              borderRadius: 6,
              position: "absolute",
              right: 135,
              bottom: 20,
            }}
          >
            <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>
              CHIUDI
            </div>
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DocScreen;
